module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Pz5yQK/tc-custom/9781607057208.jpg?1703867852841",
      "alt": "This image is the cover for the book Brave New Quilts"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Brave New Quilts\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The beloved quilt artist explores the use of line, color, motif, and text in this quilting guide featuring 12 projects inspired by modern art movements.")]), _c('br'), _c('br'), _vm._v("Kathreen Ricketson was one of Australia’s most popular modern quilt artists and bloggers. In "), _c('i', [_vm._v("Brave New Quilts")]), _vm._v(", she combines her fine art background with her love of craft to offer a series of quilts evoking the aesthetics of Art Deco, Bauhaus, Abstract Expressionism, and even Dada. Each chapter focuses on a different design principle with 3 quilt projects presented with 2 alternate design options."), _c('br'), _c('br'), _vm._v("Kathreen shares a historical overview of each art movement, giving essential context to each project. A must-have for fans of the modern quilt movement, "), _c('i', [_vm._v("Brave New Quilts")]), _vm._v(" includes expert information on color, fabric selection, inspiration, and mood boards. A comprehensive appendix and in-depth information on tools and finishing techniques round out this inspiring book.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kathreen Ricketson\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    C&T Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0